<template>
  <ng-card>
    <!-- 已经关联 -->
    <template v-if="data.email">
      <div class="detail-item">
        <h3>邮箱号码</h3>
        <div>{{data.email || '--' | omitAccount}}</div>
      </div>

      <div v-if="editable" slot="right">
        <a-button type="link" @click="handleItem($var.Handle.edit)">变更</a-button>
      </div>
    </template>
    <!-- 没有关联 -->
    <template v-else>
      <div class="detail-item">
        <h3>邮箱号码</h3>
        <div>未关联，关联后可通过手机号登录系统</div>
      </div>

      <div v-if="editable" slot="right">
        <a-button type="link" @click="handleItem($var.Handle.add)">关联</a-button>
      </div>
    </template>

    <dialog-add
      :type="type"
      :handle="handleType"
      @success="$emit('success')"
      :visible.sync="showAddDialog"
    ></dialog-add>

    <dialog-verify
      :type="type"
      :number="data.email"
      :handle="handleType"
      @change="onVerifyChange"
      :visible.sync="showVerifyDialog"
    ></dialog-verify>
  </ng-card>
</template>

<script>
  import {NgCard} from '@/components/index';
  import DialogAdd from './DialogAdd.vue';
  import DialogVerify from './DialogVerify.vue';

  export default {
    data() {
      return {
        type: 'email',
        showAddDialog: false,
        showVerifyDialog: false,
        handleType: this.$var.Handle.add,
      }
    },

    props: {
      data: {
        type: Object,
        default() {
          return {};
        }
      },
      editable: {
        type: Boolean,
        default: false,
      }
    },

    components: {
      NgCard, DialogAdd, DialogVerify
    },

    methods: {
      onVerifyChange() {
        this.showAddDialog = true;
      },

      handleItem(type) {
        this.handleType = type;

        if (type === this.$var.Handle.add) {
          this.showAddDialog = true;
        }
        else if (type === this.$var.Handle.edit) {
          this.showVerifyDialog = true;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .detail-item {
    padding: 15px;
  }
</style>
